<template>
    <div class="img-container" :class="isVertical ? 'vertical': 'horizontal'">
        <div class="notice-img" :style="`background-image: url(${noticeData.imgUrl})`" @click="$parent.giveOutLink(noticeData.linkUrl)"></div>
        <div class="txt" @click="$parent.giveOutLink(noticeData.linkUrl)">
            <h1>{{ noticeData.title }}</h1>
            <div class="content ql-editor" v-html="noticeData.content"></div>
        </div>
        <span class="notice-close" @click="$parent.closeWindow"></span>
    </div>
</template>
<script>
export default {
    name: 'PicTextComponent',
    props: {
        noticeData: {
            required: true,
            type: Object
        },
        isVertical: {
            required: true,
            type: Boolean
        }
    }
}
</script>

<style lang="less" scoped>
.img-container {
    position: absolute;
    left: 50%;
    top: 50%;
    max-width: 500px;
    max-height: 80vh;
    display: flex;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    align-items: center;
    color: #fff;
    // background-color: rgba(0, 105, 109, 0.3);
    .notice-img {
        flex: none;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        // background-color: rgba(42, 204, 115, 0.61);
    }
    .txt {
        flex: auto;
        line-height: 1.5em;
        min-width: 20px;
        box-sizing: border-box;
        // overflow: hidden;
        > h1 {
            font-size: 1.6em;
            font-weight: 500;
            margin: 0 0 .5em;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .content {
            height: auto;
            max-height: 9 * 1.5 - 0.1em;
            overflow: auto;
            padding: 0;
            // text-overflow: ellipsis;
            // display: -webkit-box;
            // -webkit-line-clamp: 9;
            // -webkit-box-orient: vertical;
            // word-break: break-all;
            // /deep/ p {
            //     margin: 0;
            // }
        }
    }
    // 横屏
    &.horizontal {
        width: 70vw;
        height: 65vh;
        .notice-img {
            width: 30vw;
            height: 30vw;
            margin-right: 1.5vw;
        }
        .txt {
            max-height: 65vh;
            overflow: auto;
            font-size: 14px;
            padding-top: 5vh;
            > h1 {
              margin-right: 1em;
            }
        }
    }
    // 竖屏
    &.vertical {
        width: 80vw;
        flex-direction: column;
        .notice-img {
            width: 74vw;
            height: 74vw;
        }
        .txt {
            width: 100%;
            font-size: 13px;
            padding: 1vh 3vw;
        }
    }
}
</style>
